<template>
    <div v-if="isShow" class="pf">
        <slot/>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "pf",
        props: {
            code: {type: String, required: true},
        },
        computed: {
            ...mapGetters({permissions: 'global/permissions'}),
            isShow() {
                return this.permissions.includes(this.code)
            }
        }
    }
</script>

<style scoped>

</style>